<div class="download-info" [ngClass]="{'downloading':isDownloading}">
  <div class="file-download" (click)="download()">
    <div class="spinner-border text-warning" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <span class="down-icon material-icons"> cloud_download </span>
  </div>
</div>
